"use strict";
exports.__esModule = true;
exports.RESCHEUDLE_LOADING_ERROR_MODAL = exports.RESCHEDULE_CONFIRMED = exports.RESCHEDULE_ERROR_MODAL = exports.CHECK_RENT_DUE_DATE_MODAL = exports.RESCHEDULE_DOWN_PAYMENT = void 0;
var common_1 = require("../../common");
exports.RESCHEDULE_DOWN_PAYMENT = {
    HEADLINE: 'Reschedule your 1st payment',
    SUBTITLE: 'This payment is required before Flex can pay your rent. Changes will only apply to this payment.',
    FEE_DISCLAIMER: common_1.FEE_DISCLAIMER.DEFAULT,
    CTA: 'Confirm'
};
exports.CHECK_RENT_DUE_DATE_MODAL = {
    TITLE: 'Check your rent due date',
    SUBTITLE: 'Flex will pay your rent on {{date}}. Your property may charge late fees if your rent is due earlier.',
    CONFIRM_CTA: 'Confirm',
    CANCEL_CTA: 'Cancel'
};
exports.RESCHEDULE_ERROR_MODAL = {
    TITLE: "Couldn't reschedule deposit",
    SUBTITLE: 'Something went wrong. Please try again later.',
    CTA: 'Done'
};
exports.RESCHEDULE_CONFIRMED = {
    HEADLINE: "You're all set!",
    TEXT: "We'll collect your 1st payment on {{date}}. Ensure funds are in your account before 8.30am EST.",
    CTA: 'Done'
};
exports.RESCHEUDLE_LOADING_ERROR_MODAL = {
    TITLE: 'Something went wrong',
    SUBTITLE: "We couldn't load this page. Please try again later.",
    CTA: 'Got it'
};
